import { ModuleFE_ColorGroup } from './ModuleFE_ColorGroup.js';
export const ModulePackFE_ColorGroup = [ModuleFE_ColorGroup];
//# sourceMappingURL=module-pack.js.map